import { CancelToken } from '@wetransfer/axios';

import { AppConfig } from '../../core-bundle/config/app-config';

import API from '@app/api';

import {
  SUPPORTED_MIME_TYPES,
  SUPPORTED_IMAGE_TYPES,
} from '@constant/mime-types';

import request from '@module/http/axios/request';

export default {
  cancelToken: null,

  allocateAsset(accountId, type, filename, curated = false) {
    const assetModelClassMapping = {
      wallpaper: 'Wallpaper',
      profile_picture: 'ProfilePicture',
      email_background: 'EmailBackground',
    };

    const options = {
      asset_model_class: assetModelClassMapping[type],
      account_id: accountId,
    };

    if (curated) {
      options.image_path = filename;
      return API.UI.allocateCuratedImage(options);
    }

    options.original_asset_filename = filename;
    return API.UI.allocateAsset(options);
  },

  uploadAsset(presignedUrl, contentType, file) {
    this.cancelToken = CancelToken.source();

    return request({
      method: 'put',
      path: presignedUrl,
      responseType: 'text',
      params: file.slice(),
      cancelToken: this.cancelToken.token,
      headers: {
        'Content-Type': contentType,
      },
    });
  },

  cancelUpload() {
    if (this.cancelToken !== null) {
      this.cancelToken.cancel();
      this.cancelToken = null;
    }
  },

  isFileValid(type, size, mimeType) {
    switch (type) {
      case 'wallpaper':
        return (
          size <= AppConfig.assetUpload.maxWallpaperSize &&
          SUPPORTED_MIME_TYPES.includes(mimeType)
        );
      case 'email_background':
        return (
          size <= AppConfig.assetUpload.maxEmailBackgroundSize &&
          SUPPORTED_IMAGE_TYPES.includes(mimeType)
        );
      case 'profile_picture':
        return (
          size <= AppConfig.assetUpload.maxProfilePictureSize &&
          SUPPORTED_IMAGE_TYPES.includes(mimeType)
        );
      default:
        return false;
    }
  },
};
